import styled from 'styled-components';

import UtmCampaign from 'pages/UtmCampaign/component';

export default styled(UtmCampaign)``;
